import { useState } from "react";
import useAuth from "../../../hooks/useAuth";
import { useCurrentUser } from "../../../hooks/useCurrentUser";
import BaseWrapper from "../../../components/ui/BaseWrapper";
import BaseButton from "../../../components/ui/BaseButton";
import CompleteProfileModal from "../../WorkJobDetails/CompleteProfileModal";

const EngineerInvoicesListingHeader = () => {
  const { userData } = useCurrentUser();
  const { authRole } = useAuth();
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);

  return (
    <>
      <div className="border-b border-zinc-300 bg-white">
        <BaseWrapper>
          <div className="py-[7px] flex justify-between">
            <h3 className="font-light">Engineer Invoices</h3>
            {/*  <div>
              <BaseButton
                color="primary"
                className="py-[4px] px-[28px]"
                onClick={() => {
                  if (userData?.status !== "APPROVED") {
                    setIsProfileCompleted(true);
                    return;
                  }
                }}
              >
                Invite Workforce
              </BaseButton>
            </div> */}
          </div>
        </BaseWrapper>
      </div>

      {isProfileCompleted && (
        <CompleteProfileModal
          isProfileCompleted={isProfileCompleted}
          setIsProfileCompleted={setIsProfileCompleted}
          status={userData?.status}
          authRole={authRole}
        />
      )}
    </>
  );
};

export default EngineerInvoicesListingHeader;
